/*
===================================================================================================
  This service will handle the weather override api request
===================================================================================================
*/

import createNewApiClient from '../apiClient';

const getWeatherOverrideRestPath = '/jetstream/api/1/getweatheroverride';

const normalizeWeatherOverrideResponse = (responseData: unknown): string => {
  if (typeof responseData === 'string') {
    return responseData.toUpperCase().trim();
  }

  if (!responseData || typeof responseData !== 'object') {
    return '';
  }

  const responseRecord = responseData as Record<string, unknown>;
  const weatherOverrideValue =
    responseRecord.airline ??
    responseRecord.airlineType ??
    responseRecord.value ??
    responseRecord.Airline ??
    responseRecord.AirlineType ??
    responseRecord.Value;

  return typeof weatherOverrideValue === 'string'
    ? weatherOverrideValue.toUpperCase().trim()
    : '';
};

const getWeatherOverrideApiRequestService = async (
  airline: string,
  accessToken?: string,
): Promise<string> => {
  // Throws error if airline is not passed in the function as parameter
  if (!airline) {
    throw new Error('Airline is not provided');
  }

  if (!accessToken?.trim()) {
    throw new Error('Access token is not provided');
  }

  const response = await createNewApiClient(accessToken).get(
    getWeatherOverrideRestPath,
    {
      params: {
        airline: airline.toString()?.trim(),
      },
    },
  );

  return normalizeWeatherOverrideResponse(response?.data);
};

export default getWeatherOverrideApiRequestService;
